import { Component } from '@angular/core';

@Component({
	selector: 'seira-footer-form',
	templateUrl: './footer-form.component.html',
	styleUrls: ['./footer-form.component.scss'],
})
export class FooterFormComponent {}
